import type { GetListingResponseBody, JsonObject } from '@/app-package';
import axios from 'axios';

export type Listing = JsonObject<
  GetListingResponseBody & {
    isUnclaimed?: boolean;
  }
>;

const getStreamChatUserIds = async (
  userIds: string[] = [],
): Promise<string[] | undefined> => {
  try {
    const url = '/streamchat/getStreamChatIds';

    const params = userIds.length > 0 ? { userIds: userIds.join(',') } : {};

    const { data } = await axios.get<string[]>(url, {
      params,
    });

    return data;
  } catch (error) {
    console.error('Error fetching Stream Chat User IDs:', error);
  }
};

export default getStreamChatUserIds;
